import { connect } from "react-redux";
import SalesforceTimelineStatusSetting from "../components/AccountSetting/Salesforce/SalesforceTimelineStatusSetting/SalesforceTimelineStatusSetting";
import { goBack, push } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  errorMessage: state.sfdcTimelineStatusSetting.errorMessage,
  shortMessage: state.sfdcTimelineStatusSetting.shortMessage,
  successMessage: state.sfdcTimelineStatusSetting.successMessage,
  // クライアントのSalesforce上のマッピング項目の候補をロード中かどうか
  isLoadingFields: state.sfdcTimelineStatusSetting.isLoadingFields,
  eventFields: state.sfdcTimelineStatusSetting.eventFields,
  expiredAccessError: state.sfdcTimelineStatusSetting.expiredAccessError,
  // DBに保存しているマッピングの情報ロード中かどうか
  isLoadingMapping: state.sfdcTimelineStatusSetting.isLoadingMapping,
  mapping: state.sfdcTimelineStatusSetting.mapping,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceDescribeTimelineStatusExport() {
    dispatch(actions.getSalesforceDescribeTimelineStatusExport());
  },

  getSalesforceExportMappings(data) {
    dispatch(actions.getSalesforceExportMappings(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceTimelineStatusSetting);



// WEBPACK FOOTER //
// ./src/containers/SalesforceTimelineStatusSetting.js